const LS_KEY = 'lpf_custom_paths';

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || '[]');
  } catch {
    return [];
  }
};

const persist = (paths) => {
  localStorage.setItem(LS_KEY, JSON.stringify(paths));
};

export const getPaths = () => readAll();

export const getPath = (id) => readAll().find((p) => p.id === id) || null;

export const createPath = ({ title, description, modules = [] }) => {
  const paths = readAll();
  const newPath = {
    id: `custom_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    title,
    description,
    modules,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    type: 'custom',
  };
  persist([...paths, newPath]);
  return newPath;
};

export const updatePath = (id, changes) => {
  const paths = readAll().map((p) =>
    p.id === id ? { ...p, ...changes, updatedAt: new Date().toISOString() } : p
  );
  persist(paths);
  return paths.find((p) => p.id === id) || null;
};

export const deletePath = (id) => {
  persist(readAll().filter((p) => p.id !== id));
};

export const addModuleToPath = (pathId, module) => {
  const paths = readAll();
  const path = paths.find((p) => p.id === pathId);
  if (!path) return null;
  const alreadyIn = path.modules.some((m) => m.uid === module.uid);
  if (alreadyIn) return path;
  const updated = {
    ...path,
    modules: [...path.modules, module],
    updatedAt: new Date().toISOString(),
  };
  persist(paths.map((p) => (p.id === pathId ? updated : p)));
  return updated;
};

export const removeModuleFromPath = (pathId, moduleUid) => {
  const paths = readAll();
  const updated = paths.map((p) =>
    p.id === pathId
      ? { ...p, modules: p.modules.filter((m) => m.uid !== moduleUid), updatedAt: new Date().toISOString() }
      : p
  );
  persist(updated);
};
